export default "__VITE_ASSET__ChS7Tla5__"